import React from 'react';

const configureFonts = config => config;
const getFontThemeList = config => Object.fromEntries(Object.entries(config).map(([key]) => [key, `'${key}', Arial, sans-serif`]));
const preloadFonts = (fontDefinitions, {
  prefix = ''
} = {}) => Object.values(fontDefinitions).filter(font => font.some(({
  preload
}) => preload)).map(font => font.filter(({
  preload
}) => preload)).flatMap(font => font.map(({
  src
}) => React.createElement("link", {
  key: src,
  as: "font",
  crossOrigin: "anonymous",
  href: `${prefix}${src}`,
  rel: "preload",
  type: getFontType(src)
})));
const getFontType = font => {
  const ending = font.split('.').pop();
  switch (ending) {
    case 'otc':
    case 'ttc':
      return 'font/collection';
    case 'svg':
    case 'svgz':
      return 'font/sfnt';
    case 'woff2':
      return 'font/woff2';
    case 'woff':
      return 'font/woff';
    case 'ttf':
      return 'font/ttf';
    case 'otf':
      return 'font/otf';
    default:
      throw new Error(`Unknown font type: ${ending}`);
  }
};

export { configureFonts, getFontThemeList, preloadFonts };
//# sourceMappingURL=index.js.map
